import {
  getFileExtensionFromFilename,
  type FileTypesType,
} from "@validereinc/utilities";
import classNames from "classnames/bind";
import React from "react";
import {
  getIconVariantFromFileExtension,
  Icon,
  IconLoading,
} from "../../../Icon";
import { Skeleton } from "../../../Skeleton";
import styles from "./FileThumbnail.module.scss";

const cx = classNames.bind(styles);

const FileThumbnail = ({
  uri,
  file,
  fileType,
  isLoading,
  isBusy,
  isValid,
}: {
  uri?: string;
  file?: File;
  fileType: FileTypesType | null;
  isLoading?: boolean;
  isBusy?: boolean;
  isValid?: boolean;
}) => {
  const fileIconVariant = file
    ? getIconVariantFromFileExtension(getFileExtensionFromFilename(file.name))
    : null;

  if (isBusy) {
    return (
      <div className={cx("container")}>
        <IconLoading speed="fast" />
      </div>
    );
  }

  if (!uri || !isValid) {
    return (
      <div className={cx("container")}>
        <Icon
          className={cx("file-preview-icon")}
          variant={!isValid ? "file-x" : (fileIconVariant ?? "custom-file")}
          size={30}
        />
      </div>
    );
  }

  const renderThumbnail = (fileType: FileTypesType | null, uri: string) => {
    switch (fileType) {
      case "IMAGE":
        return (
          <img
            className={cx("file-preview-image")}
            src={uri}
          />
        );
      default:
        return (
          <Icon
            className={cx("file-preview-icon")}
            variant={fileIconVariant ?? "custom-file"}
            size={30}
          />
        );
    }
  };

  return (
    <Skeleton isLoading={isLoading}>
      <div className={cx("container")}>{renderThumbnail(fileType, uri)}</div>
    </Skeleton>
  );
};

export default FileThumbnail;
